import { createOnPageTransitionEnd } from "@bitcart/vike-kit/lifecycle/page-transition-end"

export const onPageTransitionEnd = createOnPageTransitionEnd()
